<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 45 22.5"
  xml:space="preserve"
  version="1.1"
  class="traffic-light"
  width="45"
  height="22.5">
  <defs
      id="defs6">
      <clipPath
          id="clipPath16"
          clipPathUnits="userSpaceOnUse">
          <path
              id="path18"
              d="M 0,36 H 36 V 0 H 0 Z"
               />
      </clipPath>
  </defs>
  <g
      transform="matrix(0,1.25,1.25,0,0,-11.25)">
      <g>
          <g
              clip-path="url(#clipPath16)">
              <g
                  transform="translate(27,4)">
                  <path
                      style="fill:#292f33;fill-rule:nonzero;stroke:none"
                      d="m 0,0 c 0,-2.209 -1.791,-4 -4,-4 h -10 c -2.209,0 -4,1.791 -4,4 v 28 c 0,2.209 1.791,4 4,4 h 10 c 2.209,0 4,-1.791 4,-4 z" />
              </g>
              <g
                  transform="translate(17.9985,11)">
                  <path
                      class="light-green light"
                      [ngClass]="{'active': relay.messageStateClass === 'success'}"
                      style="fill:#77b255;fill-rule:nonzero;stroke:none"
                      d="M 0,0 C 2.21,0 4.001,-1.791 4.001,-4 4.001,-6.209 2.21,-8 0,-8 c -2.209,0 -4,1.791 -4,4 0,2.209 1.791,4 4,4" />
              </g>
              <g
                  transform="translate(17.9985,22)">
                  <path
                      class="light-orange light active"
                      [ngClass]="{'active': relay.messageStateClass === 'warning'}"
                      style="fill:#ffcc4d;fill-rule:nonzero;stroke:none"
                      d="M 0,0 C 2.21,0 4.001,-1.791 4.001,-4 4.001,-6.209 2.21,-8 0,-8 c -2.209,0 -4,1.791 -4,4 0,2.209 1.791,4 4,4" />
              </g>
              <g
                  transform="translate(17.9985,33)">
                  <path
                      class="light-red light"
                      [ngClass]="{'active': relay.messageStateClass === 'danger blinking', 'blinking': relay.messageStateClass === 'danger blinking'}"
                      style="fill:#dd2e44;fill-rule:nonzero;stroke:none"
                      d="M 0,0 C 2.21,0 4.001,-1.791 4.001,-4 4.001,-6.209 2.21,-8 0,-8 c -2.209,0 -4,1.791 -4,4 0,2.209 1.791,4 4,4" />
              </g>
          </g>
      </g>
  </g>
</svg>
